import { WordBank } from "./WordBank";
import { DifficultySystem } from "./DifficultySystem";
import { PurchaseGate } from "./PurchaseGate";
import { RunState } from "../state/RunState";

/** 文章生成管理（常に敵は1つ） */
export class Spawner {
  constructor(
    private wordBank: WordBank,
    private difficulty: DifficultySystem,
    private gate: PurchaseGate
  ) {}

  /** 次の文章テキストを取得し、stateを更新 */
  next(state: RunState): string {
    const gatedStage = this.gate.applyGate(state.stage);
    const config = this.difficulty.getConfig(gatedStage);
    const text = this.wordBank.pick(config);

    state.sentence = text;
    state.nextIndex = 0;
    state.nextChar = text.charAt(0);

    return text;
  }
}
